import { each } from 'lodash';
import { ThemeColor } from '@swell/apps-sdk';

export default async function fetchColorSchemeGroup(value) {
  each(value, (_, schemeId) => {
    each(value[schemeId].settings, (color, colorId) => {
      if (color) {
        const colorValue =
          typeof color === 'string' ? color : color.colorValues;
        value[schemeId].settings[colorId] = new ThemeColor(colorValue);
      }
    });
  });

  return value;
}
